import { useFpB2bCartService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-service'
import { Divider } from '@pets-ui/Divider/Divider'
import { Paper } from '@pets-ui/Paper/Paper'
import { VStack } from '@pets-ui/VStack/VStack'
import { Fragment } from 'react'
import { useSyncCartItemValuesToForm } from '../../../../fp-b2b-shared/hooks/use-sync-cart-item-values-to-form'
import { useStmCart } from '../../CartProvider'
import { CartListItemController } from './CartListItemController'

export const CartListItems = () => {
  const { campaignId, projectCode, countryCode, campaignCode, platform } = useStmCart()
  const { items: cartItems } = useFpB2bCartService(campaignId, platform)
  useSyncCartItemValuesToForm({ campaignId, projectCode, countryCode, campaignCode, platform })

  return (
    <Paper elevation={0} borderRadius={0}>
      <VStack>
        {cartItems?.map((item, index) => (
          <Fragment key={item.cartItemId}>
            {index > 0 && <Divider />}
            <CartListItemController item={item} index={index} />
          </Fragment>
        ))}
      </VStack>
    </Paper>
  )
}
